// // // import React, { useState, useEffect, useRef } from "react";

// // // const C = {
// // //   primary:      "#5E0E73",
// // //   primaryLight: "#6E1A85",
// // //   gold:         "#C9A84C",
// // //   goldLight:    "#E8D5A0",
// // //   dark:         "#1A0030",
// // // };

// // // /* ═══════════════════════════════════════════════════════════════
// // //    REPLACE UNSPLASH URLs WITH YOUR LOCAL IMPORTS:
// // //    import img1 from "./images/review1.jpg";  → image: img1
// // //    import vid1 from "./videos/t1.mp4";       → src: vid1
// // //    ═══════════════════════════════════════════════════════════════ */

// // // const REVIEWS = [
// // //   { name:"Aisha & Rahul",  location:"Banjara Hills",  rating:5, occasion:"Anniversary Night",   text:"Absolutely breathtaking! The fog entry, rose petals, and personalised message on the big screen made it truly magical. CarnivalCastle turned our anniversary into a night we'll never forget.", image:"https://images.unsplash.com/photo-1530103862676-de8c9debad1d?w=800&q=80", avatar:"https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=120&q=80" },
// // //   { name:"Karan Mehta",    location:"Jubilee Hills",   rating:5, occasion:"Birthday Surprise",   text:"Booked for my wife's birthday and she was completely speechless. The décor, the cake, the entire vibe — everything was flawless. Staff were super responsive on WhatsApp. Highly recommend!", image:"https://images.unsplash.com/photo-1519225421980-715cb0215aed?w=800&q=80", avatar:"https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=120&q=80" },
// // //   { name:"Sruthi Varma",   location:"Madhapur",        rating:5, occasion:"Bride To Be",          text:"The perfect way to celebrate my bestie before her wedding! Private theatre, themed décor, amazing food combos. Every single detail was taken care of — we're already planning our next event here!", image:"https://images.unsplash.com/photo-1464366400600-7168b8af9bc3?w=800&q=80", avatar:"https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=120&q=80" },
// // //   { name:"Rohit Desai",    location:"Kondapur",        rating:5, occasion:"Love Proposal",        text:"Proposed to my girlfriend here and she said YES! The team helped me plan every detail — candles, roses, a personal slideshow on the screen. It was absolutely cinematic. Best decision ever.", image:"https://images.unsplash.com/photo-1578662996442-48f60103fc96?w=800&q=80", avatar:"https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=120&q=80" },
// // //   { name:"Divya Nair",     location:"Gachibowli",      rating:5, occasion:"Mom To Be",            text:"Threw a surprise mom-to-be shower for my sister and she was in happy tears! The private space made it so cosy and intimate. The team went above and beyond in every single way.", image:"https://images.unsplash.com/photo-1464349095431-e9a21285b5f3?w=800&q=80", avatar:"https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=120&q=80" },
// // //   { name:"Arjun Pillai",   location:"Kukatpally",      rating:5, occasion:"Farewell Party",       text:"Organised a farewell for our team and it was a massive hit. Premium food platters, amazing ambience, private screening — felt like a luxury lounge. Everyone kept asking where we booked!", image:"https://images.unsplash.com/photo-1487530811015-780fb69d5cb4?w=800&q=80", avatar:"https://images.unsplash.com/photo-1552058544-f2b08422138a?w=120&q=80" },
// // // ];

// // // const VIDEOS = [
// // //   { src:null, ytId:null, thumb:"https://images.unsplash.com/photo-1530103862676-de8c9debad1d?w=800&q=80", name:"Aisha & Rahul",  event:"Anniversary Night"   },
// // //   { src:null, ytId:null, thumb:"https://images.unsplash.com/photo-1519225421980-715cb0215aed?w=800&q=80", name:"Karan Mehta",   event:"Birthday Surprise"   },
// // //   { src:null, ytId:null, thumb:"https://images.unsplash.com/photo-1578662996442-48f60103fc96?w=800&q=80", name:"Rohit & Priya", event:"Love Proposal"        },
// // // ];

// // // function Stars({ rating = 5, size = 13 }) {
// // //   return (
// // //     <div style={{ display:"flex", gap:2 }}>
// // //       {[1,2,3,4,5].map(n => (
// // //         <span key={n} style={{ fontSize:size, color: n<=rating ? C.gold : "rgba(201,168,76,.2)" }}>★</span>
// // //       ))}
// // //     </div>
// // //   );
// // // }

// // // export default function TestimonialsSection() {
// // //   const [tab,       setTab]      = useState("text");
// // //   const [activeIdx, setActiveIdx]= useState(0);
// // //   const [playIdx,   setPlayIdx]  = useState(-1);
// // //   const autoRef  = useRef(null);
// // //   const sectionRef = useRef(null);

// // //   /* ── auto-advance ── */
// // //   const startAuto = () => {
// // //     clearInterval(autoRef.current);
// // //     autoRef.current = setInterval(() =>
// // //       setActiveIdx(i => (i + 1) % REVIEWS.length), 4800);
// // //   };
// // //   useEffect(() => { startAuto(); return () => clearInterval(autoRef.current); }, []);

// // //   const goTo = i => { setActiveIdx((i + REVIEWS.length) % REVIEWS.length); clearInterval(autoRef.current); startAuto(); };

// // //   /* ── re-observe rv elements whenever tab changes ── */
// // //   useEffect(() => {
// // //     const timeout = setTimeout(() => {
// // //       if (!sectionRef.current) return;
// // //       const els = sectionRef.current.querySelectorAll(".rv-inner");
// // //       els.forEach(el => el.classList.add("rv-in"));
// // //     }, 30);
// // //     return () => clearTimeout(timeout);
// // //   }, [tab]);

// // //   const avgRating = (REVIEWS.reduce((s,r) => s + r.rating, 0) / REVIEWS.length).toFixed(1);
// // //   const cur  = REVIEWS[activeIdx];
// // //   const prev = REVIEWS[(activeIdx - 1 + REVIEWS.length) % REVIEWS.length];
// // //   const next = REVIEWS[(activeIdx + 1) % REVIEWS.length];

// // //   return (
// // //     <>
// // //       <style>{`
// // //         @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@600;700;900&family=DM+Sans:wght@300;400;500;600&display=swap');

// // //         /* ── Section ── */
// // //         .tsl-sec {
// // //           padding: 100px 0 88px;
// // //           background: ${C.dark};
// // //           position: relative; overflow: hidden;
// // //         }
// // //         .tsl-sec::before {
// // //           content: ''; position: absolute; inset: 0;
// // //           background:
// // //             radial-gradient(ellipse 70% 55% at 15% 5%,  rgba(94,14,115,.32) 0%, transparent 65%),
// // //             radial-gradient(ellipse 55% 45% at 85% 95%, rgba(201,168,76,.09) 0%, transparent 65%),
// // //             url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23fff' fill-opacity='0.018'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4z'/%3E%3C/g%3E%3C/svg%3E");
// // //           pointer-events: none;
// // //         }
// // //         .tsl-sec::after {
// // //           content: ''; position: absolute; top: 0; left: 50%; transform: translateX(-50%);
// // //           width: 200px; height: 2px;
// // //           background: linear-gradient(90deg, transparent, ${C.gold}, transparent);
// // //         }

// // //         /* ── Inner reveal (NO dependency on global rv observer) ── */
// // //         .rv-inner {
// // //           opacity: 0;
// // //           transform: translateY(24px);
// // //           transition: opacity .55s ease, transform .55s cubic-bezier(.25,1,.5,1);
// // //         }
// // //         .rv-inner.rv-in {
// // //           opacity: 1;
// // //           transform: translateY(0);
// // //         }

// // //         /* ── Header ── */
// // //         .tsl-tag {
// // //           display:inline-block; font-size:11px; font-weight:700;
// // //           letter-spacing:3px; text-transform:uppercase; color:${C.gold}; margin-bottom:10px;
// // //         }
// // //         .tsl-h {
// // //           font-family:'Playfair Display',serif;
// // //           font-size:clamp(30px,4.5vw,52px); font-weight:700; line-height:1.15; color:#fff; margin:0;
// // //         }
// // //         .tsl-h span { color:${C.gold}; }
// // //         .tsl-sub { color:rgba(255,255,255,.5); font-size:14px; line-height:1.75; margin:12px auto 0; max-width:500px; }

// // //         /* ── Stats ── */
// // //         .tsl-stats { display:flex; align-items:center; justify-content:center; gap:40px; margin-top:40px; flex-wrap:wrap; }
// // //         .tsl-stat  { text-align:center; }
// // //         .tsl-sn    { font-family:'Playfair Display',serif; font-size:34px; font-weight:700; color:${C.gold}; line-height:1; }
// // //         .tsl-sl    { font-size:10px; color:rgba(255,255,255,.4); letter-spacing:1.5px; text-transform:uppercase; margin-top:5px; }
// // //         .tsl-ssep  { width:1px; height:44px; background:rgba(255,255,255,.08); }

// // //         /* ── Tabs ── */
// // //         .tsl-tabs {
// // //           display:inline-flex; background:rgba(255,255,255,.05);
// // //           border:1px solid rgba(255,255,255,.08); border-radius:50px; padding:5px; margin-top:48px;
// // //         }
// // //         .tsl-tab {
// // //           padding:10px 28px; border-radius:50px; border:none;
// // //           font-family:'DM Sans',sans-serif; font-size:13px; font-weight:600;
// // //           cursor:pointer; transition:all .3s;
// // //         }
// // //         .tsl-tab.on {
// // //           background:linear-gradient(135deg,${C.primary},${C.primaryLight});
// // //           color:#fff; box-shadow:0 4px 18px rgba(94,14,115,.45);
// // //         }
// // //         .tsl-tab:not(.on) { background:transparent; color:rgba(255,255,255,.45); }
// // //         .tsl-tab:not(.on):hover { color:rgba(255,255,255,.75); }

// // //         /* ════ WRITTEN REVIEWS ════ */
// // //         /* ── Featured card ── */
// // //         .tsl-feat {
// // //           border-radius:28px; overflow:hidden; width:100%; height:100%;
// // //           background:rgba(255,255,255,.04); border:1px solid rgba(201,168,76,.22);
// // //           box-shadow:0 40px 90px rgba(0,0,0,.5),inset 0 1px 0 rgba(255,255,255,.06);
// // //           position:relative; transition:all .5s cubic-bezier(.25,1,.5,1);
// // //         }
// // //         .tsl-feat::before {
// // //           content:''; display:block; width:100%; height:2px;
// // //           background:linear-gradient(90deg,transparent,${C.gold},transparent);
// // //         }
// // //         .tsl-feat-in { padding:30px 28px 26px; }
// // //         .tsl-big-q {
// // //           font-family:'Playfair Display',serif; font-size:130px; font-weight:900; line-height:.8;
// // //           color:rgba(201,168,76,.055); position:absolute; top:20px; right:16px;
// // //           user-select:none; pointer-events:none;
// // //         }

// // //         .tsl-fi-wrap {
// // //           position:relative; width:100%; height:240px;
// // //           overflow:hidden; border-radius:18px; margin-bottom:22px;
// // //           box-shadow:0 14px 44px rgba(0,0,0,.45);
// // //         }
// // //         .tsl-fi {
// // //           width:100%; height:100%; object-fit:cover; display:block;
// // //           transition:transform .7s cubic-bezier(.25,1,.5,1);
// // //         }
// // //         .tsl-feat:hover .tsl-fi { transform:scale(1.04); }
// // //         .tsl-fi-ovl {
// // //           position:absolute; inset:0;
// // //           background:linear-gradient(to top,rgba(26,0,48,.75) 0%,transparent 55%);
// // //         }
// // //         .tsl-fi-badge {
// // //           position:absolute; bottom:14px; left:14px;
// // //           background:rgba(201,168,76,.18); border:1px solid rgba(201,168,76,.4);
// // //           color:${C.goldLight}; font-size:9px; font-weight:700;
// // //           letter-spacing:1.5px; text-transform:uppercase;
// // //           padding:4px 12px; border-radius:50px; backdrop-filter:blur(8px);
// // //         }

// // //         .tsl-review { font-size:15px; color:rgba(255,255,255,.82); line-height:1.8; font-style:italic; margin:0 0 22px; }
// // //         .tsl-div { height:1px; margin-bottom:18px; background:linear-gradient(90deg,transparent,rgba(201,168,76,.28),transparent); }
// // //         .tsl-author { display:flex; align-items:center; gap:14px; }
// // //         .tsl-avatar { width:52px; height:52px; border-radius:50%; object-fit:cover; flex-shrink:0; border:2.5px solid rgba(201,168,76,.45); box-shadow:0 0 0 4px rgba(201,168,76,.1); }
// // //         .tsl-aname  { font-family:'Playfair Display',serif; font-size:16px; font-weight:700; color:#fff; }
// // //         .tsl-aloc   { font-size:11px; color:rgba(255,255,255,.4); text-transform:uppercase; letter-spacing:.5px; margin-top:2px; }
// // //         .tsl-v      { margin-left:auto; flex-shrink:0; width:30px; height:30px; border-radius:50%; background:linear-gradient(135deg,${C.primary},${C.gold}); display:flex; align-items:center; justify-content:center; font-size:12px; color:#fff; font-weight:700; box-shadow:0 3px 12px rgba(201,168,76,.35); }

// // //         /* ── Preview cards ── */
// // //         .tsl-prev {
// // //           background:rgba(255,255,255,.03); border:1px solid rgba(201,168,76,.08);
// // //           border-radius:20px; overflow:hidden; cursor:pointer;
// // //           transition:all .3s; display:flex; flex-direction:column; flex:1;
// // //         }
// // //         .tsl-prev:hover { background:rgba(255,255,255,.06); border-color:rgba(201,168,76,.28); transform:translateY(-5px); box-shadow:0 18px 52px rgba(0,0,0,.45); }
// // //         .tsl-pi   { width:100%; height:155px; object-fit:cover; display:block; transition:transform .45s,filter .3s; filter:brightness(.8); }
// // //         .tsl-prev:hover .tsl-pi { transform:scale(1.05); filter:brightness(1); }
// // //         .tsl-pb   { padding:15px 17px; flex:1; display:flex; flex-direction:column; }
// // //         .tsl-pt   { font-size:12px; color:rgba(255,255,255,.55); line-height:1.65; font-style:italic; margin:8px 0 10px; flex:1; display:-webkit-box; -webkit-line-clamp:3; -webkit-box-orient:vertical; overflow:hidden; }
// // //         .tsl-pn   { font-size:13px; font-weight:700; color:rgba(255,255,255,.85); font-family:'Playfair Display',serif; }
// // //         .tsl-pl   { font-size:10px; color:rgba(255,255,255,.3); margin-top:2px; }
// // //         .tsl-pr   { display:inline-block; margin-top:10px; font-size:10px; font-weight:700; color:${C.gold}; letter-spacing:1px; text-transform:uppercase; padding:4px 12px; border:1px solid rgba(201,168,76,.25); border-radius:50px; transition:all .2s; background:transparent; width:fit-content; }
// // //         .tsl-prev:hover .tsl-pr { background:rgba(201,168,76,.12); border-color:rgba(201,168,76,.5); }

// // //         /* ── Nav ── */
// // //         .tsl-nav  { display:flex; justify-content:center; align-items:center; gap:8px; margin-top:36px; }
// // //         .tsl-dot  { width:8px; height:8px; border-radius:50%; background:rgba(255,255,255,.15); border:none; cursor:pointer; transition:all .35s cubic-bezier(.25,1,.5,1); }
// // //         .tsl-dot.on { width:34px; border-radius:4px; background:linear-gradient(90deg,${C.primary},${C.gold}); box-shadow:0 0 14px rgba(201,168,76,.4); }
// // //         .tsl-arr  { width:46px; height:46px; border-radius:50%; background:rgba(255,255,255,.06); border:1px solid rgba(255,255,255,.12); color:rgba(255,255,255,.6); font-size:20px; cursor:pointer; transition:all .25s; display:flex; align-items:center; justify-content:center; backdrop-filter:blur(8px); }
// // //         .tsl-arr:hover { background:${C.gold}; color:${C.dark}; border-color:${C.gold}; box-shadow:0 6px 20px rgba(201,168,76,.4); }

// // //         /* ════ VIDEO GRID ════ */
// // //         .vtsl-grid {
// // //           display:grid; gap:18px;
// // //           grid-template-columns:1.6fr 1fr;
// // //           grid-template-rows:260px 260px;
// // //         }
// // //         .vtsl-card {
// // //           border-radius:22px; overflow:hidden; cursor:pointer; position:relative;
// // //           background:#0D0018; border:1px solid rgba(255,255,255,.07);
// // //           transition:transform .4s cubic-bezier(.25,1,.5,1),box-shadow .4s,border-color .4s;
// // //         }
// // //         .vtsl-card:first-child { grid-row:span 2; }
// // //         .vtsl-card:hover { transform:translateY(-8px); box-shadow:0 28px 72px rgba(0,0,0,.6); border-color:rgba(201,168,76,.3); }
// // //         .vtsl-playing { border-color:rgba(201,168,76,.55)!important; box-shadow:0 0 0 2px rgba(201,168,76,.2),0 24px 64px rgba(0,0,0,.55)!important; transform:none!important; }

// // //         .vtsl-thumb { position:absolute; inset:0; background-size:cover; background-position:center; transition:transform .5s cubic-bezier(.25,1,.5,1); }
// // //         .vtsl-card:not(.vtsl-playing):hover .vtsl-thumb { transform:scale(1.06); }
// // //         .vtsl-ovl   { position:absolute; inset:0; background:linear-gradient(to top,rgba(13,0,24,.95) 0%,rgba(13,0,24,.3) 50%,rgba(13,0,24,.08) 100%); }

// // //         .vtsl-ring {
// // //           position:absolute; top:50%; left:50%; transform:translate(-50%,-50%);
// // //           width:68px; height:68px; border-radius:50%;
// // //           background:rgba(255,255,255,.1); backdrop-filter:blur(16px);
// // //           border:2px solid rgba(255,255,255,.35);
// // //           display:flex; align-items:center; justify-content:center;
// // //           transition:all .3s; box-shadow:0 8px 32px rgba(0,0,0,.4);
// // //         }
// // //         .vtsl-card:hover .vtsl-ring { background:${C.gold}; border-color:${C.gold}; transform:translate(-50%,-50%) scale(1.12); box-shadow:0 12px 40px rgba(201,168,76,.55); }
// // //         .vtsl-ring svg { fill:#fff; transition:fill .3s; }
// // //         .vtsl-card:hover .vtsl-ring svg { fill:${C.dark}; }

// // //         .vtsl-pill { position:absolute; top:16px; right:16px; background:rgba(255,255,255,.1); backdrop-filter:blur(8px); border:1px solid rgba(255,255,255,.15); color:rgba(255,255,255,.7); font-size:9px; font-weight:700; letter-spacing:2px; padding:4px 10px; border-radius:50px; transition:all .3s; }
// // //         .vtsl-card:hover .vtsl-pill { background:rgba(201,168,76,.2); border-color:rgba(201,168,76,.4); color:${C.goldLight}; }
// // //         .vtsl-dur  { position:absolute; top:16px; left:16px; background:rgba(0,0,0,.55); backdrop-filter:blur(8px); color:#fff; font-size:10px; font-weight:600; padding:3px 9px; border-radius:6px; }

// // //         .vtsl-info  { position:absolute; bottom:0; left:0; right:0; padding:22px 20px 18px; }
// // //         .vtsl-etag  { display:inline-block; margin-bottom:6px; background:rgba(201,168,76,.15); border:1px solid rgba(201,168,76,.3); color:${C.goldLight}; font-size:9px; font-weight:700; letter-spacing:1.5px; text-transform:uppercase; padding:3px 10px; border-radius:50px; }
// // //         .vtsl-vname { font-family:'Playfair Display',serif; font-size:17px; font-weight:700; color:#fff; }
// // //         .vtsl-vsub  { font-size:11px; color:rgba(255,255,255,.45); margin-top:3px; }
// // //         .vtsl-glow  { position:absolute; inset:0; border-radius:22px; border:2px solid ${C.gold}; pointer-events:none; box-shadow:inset 0 0 28px rgba(201,168,76,.12); }

// // //         .vtsl-embed { position:absolute; inset:0; }
// // //         .vtsl-embed iframe,.vtsl-embed video { width:100%; height:100%; object-fit:cover; display:block; border:none; }

// // //         /* ── Platform strip ── */
// // //         .tsl-plat { display:flex; justify-content:center; align-items:center; gap:32px; flex-wrap:wrap; margin-top:60px; padding:26px 44px; background:rgba(255,255,255,.025); border:1px solid rgba(255,255,255,.055); border-radius:22px; }
// // //         .tsl-plat-item { text-align:center; }
// // //         .tsl-plat-name { font-size:10px; color:rgba(255,255,255,.3); letter-spacing:2px; text-transform:uppercase; margin-bottom:6px; }
// // //         .tsl-plat-row  { display:flex; align-items:center; gap:7px; }
// // //         .tsl-plat-sc   { font-family:'Playfair Display',serif; font-size:22px; font-weight:700; color:#fff; }
// // //         .tsl-plat-cnt  { font-size:10px; color:rgba(255,255,255,.25); margin-top:3px; }
// // //         .tsl-psep      { width:1px; height:40px; background:rgba(255,255,255,.07); }

// // //         /* ── CTA ── */
// // //         .tsl-cta { text-align:center; margin-top:60px; padding:52px 40px; background:linear-gradient(135deg,rgba(94,14,115,.15),rgba(26,0,48,.5)); border:1px solid rgba(201,168,76,.1); border-radius:28px; position:relative; overflow:hidden; }
// // //         .tsl-cta::before { content:''; position:absolute; top:0; left:50%; transform:translateX(-50%); width:120px; height:1px; background:linear-gradient(90deg,transparent,${C.gold},transparent); }
// // //         .tsl-cta-h   { font-family:'Playfair Display',serif; font-size:clamp(22px,3vw,32px); font-weight:700; color:#fff; margin:0 0 8px; }
// // //         .tsl-cta-h span { color:${C.gold}; }
// // //         .tsl-cta-sub { font-size:14px; color:rgba(255,255,255,.4); margin-bottom:28px; }
// // //         .tsl-cta-row { display:flex; gap:14px; justify-content:center; flex-wrap:wrap; }
// // //         .tsl-btn-book { background:linear-gradient(135deg,${C.primary},${C.primaryLight}); color:#fff; border:none; border-radius:50px; padding:14px 32px; font-weight:700; font-size:14px; cursor:pointer; text-decoration:none; display:inline-block; box-shadow:0 6px 22px rgba(94,14,115,.4); transition:all .25s; }
// // //         .tsl-btn-book:hover { transform:translateY(-2px); color:#fff; box-shadow:0 12px 32px rgba(94,14,115,.55); }
// // //         .tsl-btn-wa { background:#25D366; color:#fff; border:none; border-radius:50px; padding:14px 32px; font-weight:700; font-size:14px; cursor:pointer; text-decoration:none; display:inline-flex; align-items:center; gap:8px; box-shadow:0 6px 22px rgba(37,211,102,.3); transition:all .25s; }
// // //         .tsl-btn-wa:hover { transform:translateY(-2px); background:#1ebe5d; color:#fff; }

// // //         @media(max-width:991px) {
// // //           .tsl-ssep { display:none; }
// // //           .vtsl-grid { grid-template-columns:1fr 1fr; grid-template-rows:240px 240px; }
// // //           .vtsl-card:first-child { grid-row:span 1; }
// // //           .tsl-plat { gap:20px; padding:20px 24px; }
// // //           .tsl-psep { display:none; }
// // //         }
// // //         @media(max-width:576px) {
// // //           .tsl-sec { padding:64px 0 56px; }
// // //           .vtsl-grid { grid-template-columns:1fr; grid-template-rows:auto; }
// // //           .vtsl-card { min-height:260px; }
// // //           .vtsl-card:first-child { grid-row:span 1; }
// // //           .tsl-cta { padding:36px 20px; }
// // //         }
// // //       `}</style>

// // //       <section className="tsl-sec" id="testimonials" ref={sectionRef}>
// // //         <div className="container" style={{ position:"relative", zIndex:1 }}>

// // //           {/* ── Header (always visible — no rv-inner) ── */}
// // //           <div className="text-center">
// // //             <span className="tsl-tag">✦ Guest Stories ✦</span>
// // //             <h2 className="tsl-h">Real Celebrations,<br /><span>Real Magic</span></h2>
// // //             <p className="tsl-sub">Hear from our guests — their joy, their stories, their unforgettable moments at CarnivalCastle.</p>
// // //           </div>

// // //           {/* ── Stats (always visible) ── */}
// // //           <div className="tsl-stats">
// // //             <div className="tsl-stat">
// // //               <div className="tsl-sn">{avgRating}</div>
// // //               <div style={{ display:"flex", justifyContent:"center", gap:2, margin:"5px 0 4px" }}>
// // //                 {[1,2,3,4,5].map(n=><span key={n} style={{fontSize:11,color:C.gold}}>★</span>)}
// // //               </div>
// // //               <div className="tsl-sl">Average Rating</div>
// // //             </div>
// // //             <div className="tsl-ssep"/>
// // //             <div className="tsl-stat"><div className="tsl-sn">500+</div><div className="tsl-sl">Happy Guests</div></div>
// // //             <div className="tsl-ssep"/>
// // //             <div className="tsl-stat"><div className="tsl-sn">98%</div><div className="tsl-sl">Would Return</div></div>
// // //             <div className="tsl-ssep"/>
// // //             <div className="tsl-stat"><div className="tsl-sn">4.9</div><div className="tsl-sl">Google Rating</div></div>
// // //           </div>

// // //           {/* ── Tabs (always visible) ── */}
// // //           <div style={{ display:"flex", justifyContent:"center", marginTop:48 }}>
// // //             <div className="tsl-tabs">
// // //               <button className={`tsl-tab ${tab==="text"?"on":""}`} onClick={()=>{ setTab("text"); }}>
// // //                 ✍️ Google Reviews
// // //               </button>
// // //               <button className={`tsl-tab ${tab==="video"?"on":""}`} onClick={()=>{ setTab("video"); setPlayIdx(-1); }}>
// // //                 🎬 Customer Video Testimonials 
// // //               </button>
// // //             </div>
// // //           </div>

// // //           {/* ════ WRITTEN REVIEWS ════ */}
// // //           {tab === "text" && (
// // //             <div style={{ marginTop:56 }}>
// // //               <div className="row g-4 align-items-stretch">

// // //                 {/* Featured */}
// // //                 <div className="col-lg-7" style={{ display:"flex" }}>
// // //                   <div className="tsl-feat">
// // //                     <div className="tsl-big-q">"</div>
// // //                     <div className="tsl-feat-in">
// // //                       <div className="tsl-fi-wrap">
// // //                         <img key={activeIdx} src={cur.image} alt={cur.name} className="tsl-fi" />
// // //                         <div className="tsl-fi-ovl" />
// // //                         <div className="tsl-fi-badge">🎉 {cur.occasion}</div>
// // //                       </div>
// // //                       <div style={{ marginBottom:14 }}><Stars rating={cur.rating} size={15} /></div>
// // //                       <p className="tsl-review">"{cur.text}"</p>
// // //                       <div className="tsl-div" />
// // //                       <div className="tsl-author">
// // //                         <img src={cur.avatar} alt={cur.name} className="tsl-avatar" />
// // //                         <div>
// // //                           <div className="tsl-aname">{cur.name}</div>
// // //                           <div className="tsl-aloc">{cur.location}</div>
// // //                         </div>
// // //                         <div className="tsl-v" title="Verified">✓</div>
// // //                       </div>
// // //                     </div>
// // //                   </div>
// // //                 </div>

// // //                 {/* Previews */}
// // //                 <div className="col-lg-5" style={{ display:"flex", flexDirection:"column", gap:16 }}>
// // //                   {[prev, next].map((rv, i) => (
// // //                     <div
// // //                       key={i} className="tsl-prev"
// // //                       onClick={() => goTo(i===0
// // //                         ? (activeIdx - 1 + REVIEWS.length) % REVIEWS.length
// // //                         : (activeIdx + 1) % REVIEWS.length
// // //                       )}
// // //                     >
// // //                       <img src={rv.image} alt={rv.name} className="tsl-pi" />
// // //                       <div className="tsl-pb">
// // //                         <Stars rating={rv.rating} size={11} />
// // //                         <p className="tsl-pt">"{rv.text}"</p>
// // //                         <div className="tsl-pn">{rv.name}</div>
// // //                         <div className="tsl-pl">{rv.location}</div>
// // //                         <span className="tsl-pr">Read Full →</span>
// // //                       </div>
// // //                     </div>
// // //                   ))}
// // //                 </div>
// // //               </div>

// // //               {/* Dots + Arrows */}
// // //               <div className="tsl-nav">
// // //                 <button className="tsl-arr" onClick={()=>goTo(activeIdx-1)}>‹</button>
// // //                 {REVIEWS.map((_,i) => (
// // //                   <button key={i} className={`tsl-dot ${i===activeIdx?"on":""}`} onClick={()=>goTo(i)} />
// // //                 ))}
// // //                 <button className="tsl-arr" onClick={()=>goTo(activeIdx+1)}>›</button>
// // //               </div>
// // //             </div>
// // //           )}

// // //           {/* ════ VIDEO STORIES ════ */}
// // //           {tab === "video" && (
// // //             <div style={{ marginTop:56 }}>
// // //               <div className="vtsl-grid">
// // //                 {VIDEOS.map((v, i) => (
// // //                   <div
// // //                     key={i}
// // //                     className={`vtsl-card ${playIdx===i?"vtsl-playing":""}`}
// // //                     onClick={() => setPlayIdx(playIdx===i ? -1 : i)}
// // //                   >
// // //                     {playIdx===i && (v.ytId || v.src) ? (
// // //                       <div className="vtsl-embed">
// // //                         {v.ytId
// // //                           ? <iframe src={`https://www.youtube.com/embed/${v.ytId}?autoplay=1&mute=1&rel=0`} title={v.name} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />
// // //                           : <video src={v.src} autoPlay muted playsInline controls />
// // //                         }
// // //                       </div>
// // //                     ) : (
// // //                       <>
// // //                         <div className="vtsl-thumb" style={{ backgroundImage:`url(${v.thumb})` }} />
// // //                         <div className="vtsl-ovl" />
// // //                         <div className="vtsl-dur">Tap to Play</div>
// // //                         <div className="vtsl-pill">▶ PLAY</div>
// // //                         <div className="vtsl-ring">
// // //                           <svg width="24" height="24" viewBox="0 0 24 24"><path d="M8 5v14l11-7z"/></svg>
// // //                         </div>
// // //                         <div className="vtsl-info">
// // //                           <div className="vtsl-etag">{v.event}</div>
// // //                           <div className="vtsl-vname">{v.name}</div>
// // //                           <div className="vtsl-vsub">Tap to watch their story</div>
// // //                         </div>
// // //                       </>
// // //                     )}
// // //                     {playIdx===i && <div className="vtsl-glow" />}
// // //                   </div>
// // //                 ))}
// // //               </div>
// // //               <p style={{ textAlign:"center", marginTop:16, fontSize:12, color:"rgba(255,255,255,.3)", letterSpacing:".5px" }}>
// // //                 Tap any card to play · Tap again to close
// // //               </p>
// // //             </div>
// // //           )}

// // //           {/* ── Platform ratings (always visible) ── */}
// // //           <div className="tsl-plat">
// // //             {[
// // //               { name:"Google",    score:"4.9", count:"200+ reviews"   },
// // //               { name:"Facebook",  score:"4.8", count:"150+ reviews"   },
// // //               { name:"JustDial",  score:"4.7", count:"80+ reviews"    },
// // //               { name:"Instagram", score:"5.0", count:"50k+ followers" },
// // //             ].map((p,i) => (
// // //               <React.Fragment key={i}>
// // //                 {i>0 && <div className="tsl-psep"/>}
// // //                 <div className="tsl-plat-item">
// // //                   <div className="tsl-plat-name">{p.name}</div>
// // //                   <div className="tsl-plat-row">
// // //                     <span className="tsl-plat-sc">{p.score}</span>
// // //                     <div style={{ display:"flex", gap:2 }}>{[1,2,3,4,5].map(n=><span key={n} style={{fontSize:11,color:C.gold}}>★</span>)}</div>
// // //                   </div>
// // //                   <div className="tsl-plat-cnt">{p.count}</div>
// // //                 </div>
// // //               </React.Fragment>
// // //             ))}
// // //           </div>

// // //           {/* ── CTA (always visible) ── */}
// // //           <div className="tsl-cta">
// // //             <h3 className="tsl-cta-h">Ready to Create Your <span>Own Story?</span></h3>
// // //             <p className="tsl-cta-sub">Join thousands of guests who celebrated their most special moments with us.</p>
// // //             <div className="tsl-cta-row">
// // //               <a href="/locations" className="tsl-btn-book">🎉 Book My Celebration</a>
// // //               <a href="https://wa.me/918374777834" target="_blank" rel="noopener noreferrer" className="tsl-btn-wa">
// // //                 <i className="bi bi-whatsapp"/> Chat With Us
// // //               </a>
// // //             </div>
// // //           </div>

// // //         </div>
// // //       </section>
// // //     </>
// // //   );
// // // }


// // import React, { useState, useEffect, useRef } from "react";

// // const C = {
// //   primary:      "#5E0E73",
// //   primaryLight: "#6E1A85",
// //   gold:         "#C9A84C",
// //   goldLight:    "#E8D5A0",
// //   dark:         "#1A0030",
// // };

// // // const REVIEWS = [
// // //   { name:"Aisha & Rahul",  location:"Banjara Hills",  rating:5, occasion:"Anniversary Night",   text:"Absolutely breathtaking! The fog entry, rose petals, and personalised message on the big screen made it truly magical. CarnivalCastle turned our anniversary into a night we'll never forget.", image:"https://images.unsplash.com/photo-1530103862676-de8c9debad1d?w=800&q=80", avatar:"https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=120&q=80" },
// // //   { name:"Karan Mehta",    location:"Jubilee Hills",   rating:5, occasion:"Birthday Surprise",   text:"Booked for my wife's birthday and she was completely speechless. The décor, the cake, the entire vibe — everything was flawless. Staff were super responsive on WhatsApp. Highly recommend!", image:"https://images.unsplash.com/photo-1519225421980-715cb0215aed?w=800&q=80", avatar:"https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=120&q=80" },
// // //   { name:"Sruthi Varma",   location:"Madhapur",        rating:5, occasion:"Bride To Be",          text:"The perfect way to celebrate my bestie before her wedding! Private theatre, themed décor, amazing food combos. Every single detail was taken care of — we're already planning our next event here!", image:"https://images.unsplash.com/photo-1464366400600-7168b8af9bc3?w=800&q=80", avatar:"https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=120&q=80" },
// // //   { name:"Rohit Desai",    location:"Kondapur",        rating:5, occasion:"Love Proposal",        text:"Proposed to my girlfriend here and she said YES! The team helped me plan every detail — candles, roses, a personal slideshow on the screen. It was absolutely cinematic. Best decision ever.", image:"https://images.unsplash.com/photo-1578662996442-48f60103fc96?w=800&q=80", avatar:"https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=120&q=80" },
// // //   { name:"Divya Nair",     location:"Gachibowli",      rating:5, occasion:"Mom To Be",            text:"Threw a surprise mom-to-be shower for my sister and she was in happy tears! The private space made it so cosy and intimate. The team went above and beyond in every single way.", image:"https://images.unsplash.com/photo-1464349095431-e9a21285b5f3?w=800&q=80", avatar:"https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=120&q=80" },
// // //   { name:"Arjun Pillai",   location:"Kukatpally",      rating:5, occasion:"Farewell Party",       text:"Organised a farewell for our team and it was a massive hit. Premium food platters, amazing ambience, private screening — felt like a luxury lounge. Everyone kept asking where we booked!", image:"https://images.unsplash.com/photo-1487530811015-780fb69d5cb4?w=800&q=80", avatar:"https://images.unsplash.com/photo-1552058544-f2b08422138a?w=120&q=80" },
// // // ];
// // const REVIEWS = [
// //   {
// //     name: "Sai Pavan Singh",
// //     location: "Kondapur",
// //     rating: 5,
// //     occasion: "Kids Birthday Party",
// //     text: "We celebrated my daughter’s birthday at Carnival Castle, Kondapur, and it was a really good experience overall. The place is well maintained, colorful, and perfect for kids to enjoy. The staff were supportive and handled the arrangements smoothly, which made the celebration stress-free for us. The birthday setup was done nicely, and my daughter had a great time. I'd definitely recommend Carnival Castle for kids' birthday parties in Hyderabad.",
// //     image: "https://images.unsplash.com/photo-1511795409834-ef04bbd61622?w=800&q=80",
// //     avatar: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=120&q=80"
// //   },
// //   {
// //     name: "Aashirwad Shastri",
// //     location: "Hyderabad",
// //     rating: 5,
// //     occasion: "1st Birthday Celebration",
// //     text: "Thank you, Carnival Castle, Hyderabad, for making our son's 1st birthday so special and memorable. The lovely décor, smooth arrangements, and attention to detail allowed us to simply enjoy the moment with our family. We’ll always remember how beautifully our little one’s first birthday was celebrated.",
// //     image: "https://images.unsplash.com/photo-1464349095431-e9a21285b5f3?w=800&q=80",
// //     avatar: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=120&q=80"
// //   },
// //   {
// //     name: "Ramadugu Joshna",
// //     location: "Hyderabad",
// //     rating: 5,
// //     occasion: "60th Birthday Celebration",
// //     text: "We recently celebrated a very special occasion—a 60th birthday—at Carnival Castle and couldn't have asked for a better experience. The staff went above and beyond to make sure everything ran smoothly and all our guests felt welcome. The venue had a warm, intimate atmosphere perfect for gathering with family and friends.",
// //     image: "https://images.unsplash.com/photo-1529156069898-49953e39b3ac?w=800&q=80",
// //     avatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=120&q=80"
// //   },
// //   {
// //     name: "Bharath Naidu",
// //     location: "Hyderabad",
// //     rating: 5,
// //     occasion: "Friend's Birthday Party",
// //     text: "We celebrated my friend's birthday at Carnival Castle. The decoration was beautiful, the sound quality was amazing, and the staff was very polite. Everything was managed perfectly. The pricing was reasonable for such a premium experience.",
// //     image: "https://images.unsplash.com/photo-1519225421980-715cb0215aed?w=800&q=80",
// //     avatar: "https://images.unsplash.com/photo-1552058544-f2b08422138a?w=120&q=80"
// //   },
// //   {
// //     name: "Somagutta Nandini Reddy",
// //     location: "Hyderabad",
// //     rating: 5,
// //     occasion: "Special Celebration",
// //     text: "I want to express my heartfelt appreciation for the incredible arrangements. The attention to detail was outstanding, creating a magical and unforgettable atmosphere. The friendly and accommodating staff made the experience even more enjoyable. Special thanks for the exceptional photography that captured every moment beautifully.",
// //     image: "https://images.unsplash.com/photo-1485879136085-498cc6f92f7f?w=800&q=80",
// //     avatar: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=120&q=80"
// //   },
// //   {
// //     name: "S D",
// //     location: "Hyderabad",
// //     rating: 5,
// //     occasion: "Family Celebration",
// //     text: "This place has given us beautiful memories. I loved the services they provided. Every single rupee is worth spending here. Thank you Rohit and team for making people happy. I am very much impressed with the overall experience.",
// //     image: "https://images.unsplash.com/photo-1517457373958-b7bdd4587205?w=800&q=80",
// //     avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=120&q=80"
// //   },
// //   {
// //     name: "Dr. Manjula Ch. M.",
// //     location: "Hyderabad",
// //     rating: 5,
// //     occasion: "Private Theatre Experience",
// //     text: "My first experience has transformed into a treasured memory. Communicating for arrangements was easy and well coordinated by the team. The décor and ambience were lovely. The private theatre itself is an amazing experience, and together with Carnival Castle's team, it became truly memorable.",
// //     image: "https://images.unsplash.com/photo-1578662996442-48f60103fc96?w=800&q=80",
// //     avatar: "https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?w=120&q=80"
// //   },
// //   {
// //     name: "Srinivas Vadlamudi",
// //     location: "Hyderabad",
// //     rating: 5,
// //     occasion: "Birthday Party",
// //     text: "The team and support staff were excellent. We recently hosted a birthday party here. The atmosphere was pleasant, the food was delicious, and everything was fantastic. The decorations, mini projector, and tidy recliners added to the experience. I highly recommend this venue for birthdays and wedding anniversaries.",
// //     image: "https://images.unsplash.com/photo-1487530811015-780fb69d5cb4?w=800&q=80",
// //     avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=120&q=80"
// //   }
// // ];

// // function Stars({ rating = 5, size = 13 }) {
// //   return (
// //     <div style={{ display:"flex", gap:2 }}>
// //       {[1,2,3,4,5].map(n => (
// //         <span key={n} style={{ fontSize:size, color: n<=rating ? C.gold : "rgba(201,168,76,.2)" }}>★</span>
// //       ))}
// //     </div>
// //   );
// // }

// // export default function TestimonialsSection() {
// //   const [activeIdx, setActiveIdx] = useState(0);
// //   const autoRef    = useRef(null);
// //   const sectionRef = useRef(null);

// //   const startAuto = () => {
// //     clearInterval(autoRef.current);
// //     autoRef.current = setInterval(() =>
// //       setActiveIdx(i => (i + 1) % REVIEWS.length), 4800);
// //   };
// //   useEffect(() => { startAuto(); return () => clearInterval(autoRef.current); }, []);

// //   const goTo = i => {
// //     setActiveIdx((i + REVIEWS.length) % REVIEWS.length);
// //     clearInterval(autoRef.current);
// //     startAuto();
// //   };

// //   const avgRating = (REVIEWS.reduce((s,r) => s + r.rating, 0) / REVIEWS.length).toFixed(1);
// //   const cur  = REVIEWS[activeIdx];
// //   const prev = REVIEWS[(activeIdx - 1 + REVIEWS.length) % REVIEWS.length];
// //   const next = REVIEWS[(activeIdx + 1) % REVIEWS.length];

// //   return (
// //     <>
// //       <style>{`
// //         @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@600;700;900&family=DM+Sans:wght@300;400;500;600&display=swap');

// //         .tsl-sec {
// //           padding: 100px 0 88px;
// //           background: ${C.dark};
// //           position: relative; overflow: hidden;
// //         }
// //         .tsl-sec::before {
// //           content: ''; position: absolute; inset: 0;
// //           background:
// //             radial-gradient(ellipse 70% 55% at 15% 5%,  rgba(94,14,115,.32) 0%, transparent 65%),
// //             radial-gradient(ellipse 55% 45% at 85% 95%, rgba(201,168,76,.09) 0%, transparent 65%),
// //             url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23fff' fill-opacity='0.018'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4z'/%3E%3C/g%3E%3C/svg%3E");
// //           pointer-events: none;
// //         }
// //         .tsl-sec::after {
// //           content: ''; position: absolute; top: 0; left: 50%; transform: translateX(-50%);
// //           width: 200px; height: 2px;
// //           background: linear-gradient(90deg, transparent, ${C.gold}, transparent);
// //         }

// //         .tsl-tag { display:inline-block; font-size:11px; font-weight:700; letter-spacing:3px; text-transform:uppercase; color:${C.gold}; margin-bottom:10px; }
// //         .tsl-h   { font-family:'Playfair Display',serif; font-size:clamp(30px,4.5vw,52px); font-weight:700; line-height:1.15; color:#fff; margin:0; }
// //         .tsl-h span { color:${C.gold}; }
// //         .tsl-sub { color:rgba(255,255,255,.5); font-size:14px; line-height:1.75; margin:12px auto 0; max-width:500px; }

// //         .tsl-stats { display:flex; align-items:center; justify-content:center; gap:40px; margin-top:40px; flex-wrap:wrap; }
// //         .tsl-stat  { text-align:center; }
// //         .tsl-sn    { font-family:'Playfair Display',serif; font-size:34px; font-weight:700; color:${C.gold}; line-height:1; }
// //         .tsl-sl    { font-size:10px; color:rgba(255,255,255,.4); letter-spacing:1.5px; text-transform:uppercase; margin-top:5px; }
// //         .tsl-ssep  { width:1px; height:44px; background:rgba(255,255,255,.08); }

// //         /* featured */
// //         .tsl-feat {
// //           border-radius:28px; overflow:hidden; width:100%; height:100%;
// //           background:rgba(255,255,255,.04); border:1px solid rgba(201,168,76,.22);
// //           box-shadow:0 40px 90px rgba(0,0,0,.5),inset 0 1px 0 rgba(255,255,255,.06);
// //           position:relative; transition:all .5s cubic-bezier(.25,1,.5,1);
// //         }
// //         .tsl-feat::before { content:''; display:block; width:100%; height:2px; background:linear-gradient(90deg,transparent,${C.gold},transparent); }
// //         .tsl-feat-in { padding:30px 28px 26px; }
// //         .tsl-big-q { font-family:'Playfair Display',serif; font-size:130px; font-weight:900; line-height:.8; color:rgba(201,168,76,.055); position:absolute; top:20px; right:16px; user-select:none; pointer-events:none; }

// //         .tsl-fi-wrap { position:relative; width:100%; height:240px; overflow:hidden; border-radius:18px; margin-bottom:22px; box-shadow:0 14px 44px rgba(0,0,0,.45); }
// //         .tsl-fi { width:100%; height:100%; object-fit:cover; display:block; transition:transform .7s cubic-bezier(.25,1,.5,1); }
// //         .tsl-feat:hover .tsl-fi { transform:scale(1.04); }
// //         .tsl-fi-ovl { position:absolute; inset:0; background:linear-gradient(to top,rgba(26,0,48,.75) 0%,transparent 55%); }
// //         .tsl-fi-badge { position:absolute; bottom:14px; left:14px; background:rgba(201,168,76,.18); border:1px solid rgba(201,168,76,.4); color:${C.goldLight}; font-size:9px; font-weight:700; letter-spacing:1.5px; text-transform:uppercase; padding:4px 12px; border-radius:50px; backdrop-filter:blur(8px); }

// //         .tsl-review { font-size:15px; color:rgba(255,255,255,.82); line-height:1.8; font-style:italic; margin:0 0 22px; }
// //         .tsl-div    { height:1px; margin-bottom:18px; background:linear-gradient(90deg,transparent,rgba(201,168,76,.28),transparent); }
// //         .tsl-author { display:flex; align-items:center; gap:14px; }
// //         .tsl-avatar { width:52px; height:52px; border-radius:50%; object-fit:cover; flex-shrink:0; border:2.5px solid rgba(201,168,76,.45); box-shadow:0 0 0 4px rgba(201,168,76,.1); }
// //         .tsl-aname  { font-family:'Playfair Display',serif; font-size:16px; font-weight:700; color:#fff; }
// //         .tsl-aloc   { font-size:11px; color:rgba(255,255,255,.4); text-transform:uppercase; letter-spacing:.5px; margin-top:2px; }
// //         .tsl-v      { margin-left:auto; flex-shrink:0; width:30px; height:30px; border-radius:50%; background:linear-gradient(135deg,${C.primary},${C.gold}); display:flex; align-items:center; justify-content:center; font-size:12px; color:#fff; font-weight:700; box-shadow:0 3px 12px rgba(201,168,76,.35); }

// //         /* preview cards */
// //         .tsl-prev { background:rgba(255,255,255,.03); border:1px solid rgba(201,168,76,.08); border-radius:20px; overflow:hidden; cursor:pointer; transition:all .3s; display:flex; flex-direction:column; flex:1; }
// //         .tsl-prev:hover { background:rgba(255,255,255,.06); border-color:rgba(201,168,76,.28); transform:translateY(-5px); box-shadow:0 18px 52px rgba(0,0,0,.45); }
// //         .tsl-pi  { width:100%; height:155px; object-fit:cover; display:block; transition:transform .45s,filter .3s; filter:brightness(.8); }
// //         .tsl-prev:hover .tsl-pi { transform:scale(1.05); filter:brightness(1); }
// //         .tsl-pb  { padding:15px 17px; flex:1; display:flex; flex-direction:column; }
// //         .tsl-pt  { font-size:12px; color:rgba(255,255,255,.55); line-height:1.65; font-style:italic; margin:8px 0 10px; flex:1; display:-webkit-box; -webkit-line-clamp:3; -webkit-box-orient:vertical; overflow:hidden; }
// //         .tsl-pn  { font-size:13px; font-weight:700; color:rgba(255,255,255,.85); font-family:'Playfair Display',serif; }
// //         .tsl-pl  { font-size:10px; color:rgba(255,255,255,.3); margin-top:2px; }
// //         .tsl-pr  { display:inline-block; margin-top:10px; font-size:10px; font-weight:700; color:${C.gold}; letter-spacing:1px; text-transform:uppercase; padding:4px 12px; border:1px solid rgba(201,168,76,.25); border-radius:50px; transition:all .2s; background:transparent; width:fit-content; }
// //         .tsl-prev:hover .tsl-pr { background:rgba(201,168,76,.12); border-color:rgba(201,168,76,.5); }

// //         /* nav */
// //         .tsl-nav  { display:flex; justify-content:center; align-items:center; gap:8px; margin-top:36px; }
// //         .tsl-dot  { width:8px; height:8px; border-radius:50%; background:rgba(255,255,255,.15); border:none; cursor:pointer; transition:all .35s cubic-bezier(.25,1,.5,1); }
// //         .tsl-dot.on { width:34px; border-radius:4px; background:linear-gradient(90deg,${C.primary},${C.gold}); box-shadow:0 0 14px rgba(201,168,76,.4); }
// //         .tsl-arr  { width:46px; height:46px; border-radius:50%; background:rgba(255,255,255,.06); border:1px solid rgba(255,255,255,.12); color:rgba(255,255,255,.6); font-size:20px; cursor:pointer; transition:all .25s; display:flex; align-items:center; justify-content:center; backdrop-filter:blur(8px); }
// //         .tsl-arr:hover { background:${C.gold}; color:${C.dark}; border-color:${C.gold}; box-shadow:0 6px 20px rgba(201,168,76,.4); }

// //         /* platform strip */
// //         .tsl-plat { display:flex; justify-content:center; align-items:center; gap:32px; flex-wrap:wrap; margin-top:60px; padding:26px 44px; background:rgba(255,255,255,.025); border:1px solid rgba(255,255,255,.055); border-radius:22px; }
// //         .tsl-plat-item { text-align:center; }
// //         .tsl-plat-name { font-size:10px; color:rgba(255,255,255,.3); letter-spacing:2px; text-transform:uppercase; margin-bottom:6px; }
// //         .tsl-plat-row  { display:flex; align-items:center; gap:7px; }
// //         .tsl-plat-sc   { font-family:'Playfair Display',serif; font-size:22px; font-weight:700; color:#fff; }
// //         .tsl-plat-cnt  { font-size:10px; color:rgba(255,255,255,.25); margin-top:3px; }
// //         .tsl-psep      { width:1px; height:40px; background:rgba(255,255,255,.07); }

// //         /* CTA */
// //         .tsl-cta { text-align:center; margin-top:60px; padding:52px 40px; background:linear-gradient(135deg,rgba(94,14,115,.15),rgba(26,0,48,.5)); border:1px solid rgba(201,168,76,.1); border-radius:28px; position:relative; overflow:hidden; }
// //         .tsl-cta::before { content:''; position:absolute; top:0; left:50%; transform:translateX(-50%); width:120px; height:1px; background:linear-gradient(90deg,transparent,${C.gold},transparent); }
// //         .tsl-cta-h   { font-family:'Playfair Display',serif; font-size:clamp(22px,3vw,32px); font-weight:700; color:#fff; margin:0 0 8px; }
// //         .tsl-cta-h span { color:${C.gold}; }
// //         .tsl-cta-sub { font-size:14px; color:rgba(255,255,255,.4); margin-bottom:28px; }
// //         .tsl-cta-row { display:flex; gap:14px; justify-content:center; flex-wrap:wrap; }
// //         .tsl-btn-book { background:linear-gradient(135deg,${C.primary},${C.primaryLight}); color:#fff; border:none; border-radius:50px; padding:14px 32px; font-weight:700; font-size:14px; cursor:pointer; text-decoration:none; display:inline-block; box-shadow:0 6px 22px rgba(94,14,115,.4); transition:all .25s; }
// //         .tsl-btn-book:hover { transform:translateY(-2px); color:#fff; box-shadow:0 12px 32px rgba(94,14,115,.55); }
// //         .tsl-btn-wa { background:#25D366; color:#fff; border:none; border-radius:50px; padding:14px 32px; font-weight:700; font-size:14px; cursor:pointer; text-decoration:none; display:inline-flex; align-items:center; gap:8px; box-shadow:0 6px 22px rgba(37,211,102,.3); transition:all .25s; }
// //         .tsl-btn-wa:hover { transform:translateY(-2px); background:#1ebe5d; color:#fff; }

// //         @media(max-width:991px) { .tsl-ssep{display:none;} .tsl-plat{gap:20px;padding:20px 24px;} .tsl-psep{display:none;} }
// //         @media(max-width:576px) { .tsl-sec{padding:64px 0 56px;} .tsl-cta{padding:36px 20px;} }
// //       `}</style>

// //       <section className="tsl-sec" id="testimonials" ref={sectionRef}>
// //         <div className="container" style={{ position:"relative", zIndex:1 }}>

// //           <div className="text-center">
// //             <span className="tsl-tag">✦ Guest Stories ✦</span>
// //             <h2 className="tsl-h">Real Celebrations,<br /><span>Real Magic</span></h2>
// //             <p className="tsl-sub">Hear from our guests — their joy, their stories, their unforgettable moments at CarnivalCastle.</p>
// //           </div>

// //           <div className="tsl-stats">
// //             <div className="tsl-stat">
// //               <div className="tsl-sn">{avgRating}</div>
// //               <div style={{ display:"flex", justifyContent:"center", gap:2, margin:"5px 0 4px" }}>
// //                 {[1,2,3,4,5].map(n=><span key={n} style={{fontSize:11,color:C.gold}}>★</span>)}
// //               </div>
// //               <div className="tsl-sl">Average Rating</div>
// //             </div>
// //             <div className="tsl-ssep"/>
// //             <div className="tsl-stat"><div className="tsl-sn">500+</div><div className="tsl-sl">Happy Guests</div></div>
// //             <div className="tsl-ssep"/>
// //             <div className="tsl-stat"><div className="tsl-sn">98%</div><div className="tsl-sl">Would Return</div></div>
// //             <div className="tsl-ssep"/>
// //             <div className="tsl-stat"><div className="tsl-sn">4.9</div><div className="tsl-sl">Google Rating</div></div>
// //           </div>

// //           {/* Reviews */}
// //           <div style={{ marginTop:56 }}>
// //             <div className="row g-4 align-items-stretch">
// //               <div className="col-lg-7" style={{ display:"flex" }}>
// //                 <div className="tsl-feat">
// //                   <div className="tsl-big-q">"</div>
// //                   <div className="tsl-feat-in">
// //                     <div className="tsl-fi-wrap">
// //                       <img key={activeIdx} src={cur.image} alt={cur.name} className="tsl-fi" />
// //                       <div className="tsl-fi-ovl" />
// //                       <div className="tsl-fi-badge">🎉 {cur.occasion}</div>
// //                     </div>
// //                     <div style={{ marginBottom:14 }}><Stars rating={cur.rating} size={15} /></div>
// //                     <p className="tsl-review">"{cur.text}"</p>
// //                     <div className="tsl-div" />
// //                     <div className="tsl-author">
// //                       <img src={cur.avatar} alt={cur.name} className="tsl-avatar" />
// //                       <div>
// //                         <div className="tsl-aname">{cur.name}</div>
// //                         <div className="tsl-aloc">{cur.location}</div>
// //                       </div>
// //                       <div className="tsl-v" title="Verified">✓</div>
// //                     </div>
// //                   </div>
// //                 </div>
// //               </div>
// //               <div className="col-lg-5" style={{ display:"flex", flexDirection:"column", gap:16 }}>
// //                 {[prev, next].map((rv, i) => (
// //                   <div
// //                     key={i} className="tsl-prev"
// //                     onClick={() => goTo(i===0
// //                       ? (activeIdx - 1 + REVIEWS.length) % REVIEWS.length
// //                       : (activeIdx + 1) % REVIEWS.length
// //                     )}
// //                   >
// //                     <img src={rv.image} alt={rv.name} className="tsl-pi" />
// //                     <div className="tsl-pb">
// //                       <Stars rating={rv.rating} size={11} />
// //                       <p className="tsl-pt">"{rv.text}"</p>
// //                       <div className="tsl-pn">{rv.name}</div>
// //                       <div className="tsl-pl">{rv.location}</div>
// //                       <span className="tsl-pr">Read Full →</span>
// //                     </div>
// //                   </div>
// //                 ))}
// //               </div>
// //             </div>

// //             <div className="tsl-nav">
// //               <button className="tsl-arr" onClick={()=>goTo(activeIdx-1)}>‹</button>
// //               {REVIEWS.map((_,i) => (
// //                 <button key={i} className={`tsl-dot ${i===activeIdx?"on":""}`} onClick={()=>goTo(i)} />
// //               ))}
// //               <button className="tsl-arr" onClick={()=>goTo(activeIdx+1)}>›</button>
// //             </div>
// //           </div>

// //           <div className="tsl-plat">
// //             {[
// //               { name:"Google",    score:"4.9", count:"200+ reviews"   },
// //               { name:"Facebook",  score:"4.8", count:"150+ reviews"   },
// //               { name:"JustDial",  score:"4.7", count:"80+ reviews"    },
// //               { name:"Instagram", score:"5.0", count:"50k+ followers" },
// //             ].map((p,i) => (
// //               <React.Fragment key={i}>
// //                 {i>0 && <div className="tsl-psep"/>}
// //                 <div className="tsl-plat-item">
// //                   <div className="tsl-plat-name">{p.name}</div>
// //                   <div className="tsl-plat-row">
// //                     <span className="tsl-plat-sc">{p.score}</span>
// //                     <div style={{ display:"flex", gap:2 }}>{[1,2,3,4,5].map(n=><span key={n} style={{fontSize:11,color:C.gold}}>★</span>)}</div>
// //                   </div>
// //                   <div className="tsl-plat-cnt">{p.count}</div>
// //                 </div>
// //               </React.Fragment>
// //             ))}
// //           </div>

// //           <div className="tsl-cta">
// //             <h3 className="tsl-cta-h">Ready to Create Your <span>Own Story?</span></h3>
// //             <p className="tsl-cta-sub">Join thousands of guests who celebrated their most special moments with us.</p>
// //             <div className="tsl-cta-row">
// //               <a href="/locations" className="tsl-btn-book">🎉 Book My Celebration</a>
// //               <a href="https://wa.me/918374777834" target="_blank" rel="noopener noreferrer" className="tsl-btn-wa">
// //                 <i className="bi bi-whatsapp"/> Chat With Us
// //               </a>
// //             </div>
// //           </div>

// //         </div>
// //       </section>
// //     </>
// //   );
// // }


// import React, { useState, useEffect, useRef } from "react";

// // ─── paste your existing C object or import it ───
// const C = {
//   primary:      "#5E0E73",
//   primaryLight: "#6E1A85",
//   gold:         "#C9A84C",
//   goldLight:    "#E8D5A0",
//   dark:         "#1A0030",
// };

// function Stars({ rating = 5, size = 13 }) {
//   return (
//     <div style={{ display: "flex", gap: 2 }}>
//       {[1, 2, 3, 4, 5].map(n => (
//         <span key={n} style={{ fontSize: size, color: n <= rating ? C.gold : "rgba(201,168,76,.2)" }}>★</span>
//       ))}
//     </div>
//   );
// }

// /**
//  * Drop this component anywhere in your JSX tree.
//  *
//  * Props:
//  *   slides  — your existing `slides` state (array of groups, each group = array of rv objects)
//  *             rv shape: { name, location, rating, occasion, description, image, avatar }
//  *
//  * Usage inside your page:
//  *   {slides.length > 0 && <TestimonialsSection slides={slides} />}
//  */
// export default function TestimonialsSection({ slides = [] }) {
//   // Flatten your grouped slides into a flat reviews array and map `description` → `text`
//   const REVIEWS = slides.flat().map(rv => ({
//     name:     rv.name,
//     location: rv.location,
//     rating:   rv.rating,
//     occasion: rv.occasion,
//     text:     rv.description ?? rv.text ?? "",
//     image:    rv.image,
//     avatar:   rv.avatar,
//   }));

//   const [activeIdx, setActiveIdx] = useState(0);
//   const autoRef    = useRef(null);

//   const startAuto = () => {
//     clearInterval(autoRef.current);
//     autoRef.current = setInterval(
//       () => setActiveIdx(i => (i + 1) % REVIEWS.length),
//       4800
//     );
//   };

//   useEffect(() => {
//     if (REVIEWS.length === 0) return;
//     startAuto();
//     return () => clearInterval(autoRef.current);
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [REVIEWS.length]);

//   if (REVIEWS.length === 0) return null;

//   const goTo = i => {
//     setActiveIdx((i + REVIEWS.length) % REVIEWS.length);
//     clearInterval(autoRef.current);
//     startAuto();
//   };

//   const avgRating = (REVIEWS.reduce((s, r) => s + r.rating, 0) / REVIEWS.length).toFixed(1);
//   const cur  = REVIEWS[activeIdx];
//   const prev = REVIEWS[(activeIdx - 1 + REVIEWS.length) % REVIEWS.length];
//   const next = REVIEWS[(activeIdx + 1) % REVIEWS.length];

//   return (
//     <>
//       <style>{`
//         @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@600;700;900&family=DM+Sans:wght@300;400;500;600&display=swap');

//         .tsl-sec {
//           padding: 100px 0 88px;
//           background: ${C.dark};
//           position: relative; overflow: hidden;
//         }
//         .tsl-sec::before {
//           content: ''; position: absolute; inset: 0;
//           background:
//             radial-gradient(ellipse 70% 55% at 15% 5%,  rgba(94,14,115,.32) 0%, transparent 65%),
//             radial-gradient(ellipse 55% 45% at 85% 95%, rgba(201,168,76,.09) 0%, transparent 65%),
//             url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23fff' fill-opacity='0.018'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4z'/%3E%3C/g%3E%3C/svg%3E");
//           pointer-events: none;
//         }
//         .tsl-sec::after {
//           content: ''; position: absolute; top: 0; left: 50%; transform: translateX(-50%);
//           width: 200px; height: 2px;
//           background: linear-gradient(90deg, transparent, ${C.gold}, transparent);
//         }

//         .tsl-tag { display:inline-block; font-size:11px; font-weight:700; letter-spacing:3px; text-transform:uppercase; color:${C.gold}; margin-bottom:10px; }
//         .tsl-h   { font-family:'Playfair Display',serif; font-size:clamp(30px,4.5vw,52px); font-weight:700; line-height:1.15; color:#fff; margin:0; }
//         .tsl-h span { color:${C.gold}; }
//         .tsl-sub { color:rgba(255,255,255,.5); font-size:14px; line-height:1.75; margin:12px auto 0; max-width:500px; }

//         .tsl-stats { display:flex; align-items:center; justify-content:center; gap:40px; margin-top:40px; flex-wrap:wrap; }
//         .tsl-stat  { text-align:center; }
//         .tsl-sn    { font-family:'Playfair Display',serif; font-size:34px; font-weight:700; color:${C.gold}; line-height:1; }
//         .tsl-sl    { font-size:10px; color:rgba(255,255,255,.4); letter-spacing:1.5px; text-transform:uppercase; margin-top:5px; }
//         .tsl-ssep  { width:1px; height:44px; background:rgba(255,255,255,.08); }

//         /* featured card */
//         .tsl-feat {
//           border-radius:28px; overflow:hidden; width:100%; height:100%;
//           background:rgba(255,255,255,.04); border:1px solid rgba(201,168,76,.22);
//           box-shadow:0 40px 90px rgba(0,0,0,.5),inset 0 1px 0 rgba(255,255,255,.06);
//           position:relative; transition:all .5s cubic-bezier(.25,1,.5,1);
//         }
//         .tsl-feat::before { content:''; display:block; width:100%; height:2px; background:linear-gradient(90deg,transparent,${C.gold},transparent); }
//         .tsl-feat-in { padding:30px 28px 26px; }
//         .tsl-big-q { font-family:'Playfair Display',serif; font-size:130px; font-weight:900; line-height:.8; color:rgba(201,168,76,.055); position:absolute; top:20px; right:16px; user-select:none; pointer-events:none; }

//         .tsl-fi-wrap { position:relative; width:100%; height:240px; overflow:hidden; border-radius:18px; margin-bottom:22px; box-shadow:0 14px 44px rgba(0,0,0,.45); }
//         .tsl-fi { width:100%; height:100%; object-fit:cover; display:block; transition:transform .7s cubic-bezier(.25,1,.5,1); }
//         .tsl-feat:hover .tsl-fi { transform:scale(1.04); }
//         .tsl-fi-ovl { position:absolute; inset:0; background:linear-gradient(to top,rgba(26,0,48,.75) 0%,transparent 55%); }
//         .tsl-fi-badge { position:absolute; bottom:14px; left:14px; background:rgba(201,168,76,.18); border:1px solid rgba(201,168,76,.4); color:${C.goldLight}; font-size:9px; font-weight:700; letter-spacing:1.5px; text-transform:uppercase; padding:4px 12px; border-radius:50px; backdrop-filter:blur(8px); }

//         .tsl-review { font-size:15px; color:rgba(255,255,255,.82); line-height:1.8; font-style:italic; margin:0 0 22px; }
//         .tsl-div    { height:1px; margin-bottom:18px; background:linear-gradient(90deg,transparent,rgba(201,168,76,.28),transparent); }
//         .tsl-author { display:flex; align-items:center; gap:14px; }
//         .tsl-avatar { width:52px; height:52px; border-radius:50%; object-fit:cover; flex-shrink:0; border:2.5px solid rgba(201,168,76,.45); box-shadow:0 0 0 4px rgba(201,168,76,.1); }
//         .tsl-aname  { font-family:'Playfair Display',serif; font-size:16px; font-weight:700; color:#fff; }
//         .tsl-aloc   { font-size:11px; color:rgba(255,255,255,.4); text-transform:uppercase; letter-spacing:.5px; margin-top:2px; }
//         .tsl-v      { margin-left:auto; flex-shrink:0; width:30px; height:30px; border-radius:50%; background:linear-gradient(135deg,${C.primary},${C.gold}); display:flex; align-items:center; justify-content:center; font-size:12px; color:#fff; font-weight:700; box-shadow:0 3px 12px rgba(201,168,76,.35); }

//         /* preview cards */
//         .tsl-prev { background:rgba(255,255,255,.03); border:1px solid rgba(201,168,76,.08); border-radius:20px; overflow:hidden; cursor:pointer; transition:all .3s; display:flex; flex-direction:column; flex:1; }
//         .tsl-prev:hover { background:rgba(255,255,255,.06); border-color:rgba(201,168,76,.28); transform:translateY(-5px); box-shadow:0 18px 52px rgba(0,0,0,.45); }
//         .tsl-pi  { width:100%; height:155px; object-fit:cover; display:block; transition:transform .45s,filter .3s; filter:brightness(.8); }
//         .tsl-prev:hover .tsl-pi { transform:scale(1.05); filter:brightness(1); }
//         .tsl-pb  { padding:15px 17px; flex:1; display:flex; flex-direction:column; }
//         .tsl-pt  { font-size:12px; color:rgba(255,255,255,.55); line-height:1.65; font-style:italic; margin:8px 0 10px; flex:1; display:-webkit-box; -webkit-line-clamp:3; -webkit-box-orient:vertical; overflow:hidden; }
//         .tsl-pn  { font-size:13px; font-weight:700; color:rgba(255,255,255,.85); font-family:'Playfair Display',serif; }
//         .tsl-pl  { font-size:10px; color:rgba(255,255,255,.3); margin-top:2px; }
//         .tsl-pr  { display:inline-block; margin-top:10px; font-size:10px; font-weight:700; color:${C.gold}; letter-spacing:1px; text-transform:uppercase; padding:4px 12px; border:1px solid rgba(201,168,76,.25); border-radius:50px; transition:all .2s; background:transparent; width:fit-content; }
//         .tsl-prev:hover .tsl-pr { background:rgba(201,168,76,.12); border-color:rgba(201,168,76,.5); }

//         /* nav */
//         .tsl-nav  { display:flex; justify-content:center; align-items:center; gap:8px; margin-top:36px; }
//         .tsl-dot  { width:8px; height:8px; border-radius:50%; background:rgba(255,255,255,.15); border:none; cursor:pointer; transition:all .35s cubic-bezier(.25,1,.5,1); padding:0; }
//         .tsl-dot.on { width:34px; border-radius:4px; background:linear-gradient(90deg,${C.primary},${C.gold}); box-shadow:0 0 14px rgba(201,168,76,.4); }
//         .tsl-arr  { width:46px; height:46px; border-radius:50%; background:rgba(255,255,255,.06); border:1px solid rgba(255,255,255,.12); color:rgba(255,255,255,.6); font-size:20px; cursor:pointer; transition:all .25s; display:flex; align-items:center; justify-content:center; backdrop-filter:blur(8px); }
//         .tsl-arr:hover { background:${C.gold}; color:${C.dark}; border-color:${C.gold}; box-shadow:0 6px 20px rgba(201,168,76,.4); }

//         /* platform strip */
//         .tsl-plat { display:flex; justify-content:center; align-items:center; gap:32px; flex-wrap:wrap; margin-top:60px; padding:26px 44px; background:rgba(255,255,255,.025); border:1px solid rgba(255,255,255,.055); border-radius:22px; }
//         .tsl-plat-item { text-align:center; }
//         .tsl-plat-name { font-size:10px; color:rgba(255,255,255,.3); letter-spacing:2px; text-transform:uppercase; margin-bottom:6px; }
//         .tsl-plat-row  { display:flex; align-items:center; gap:7px; }
//         .tsl-plat-sc   { font-family:'Playfair Display',serif; font-size:22px; font-weight:700; color:#fff; }
//         .tsl-plat-cnt  { font-size:10px; color:rgba(255,255,255,.25); margin-top:3px; }
//         .tsl-psep      { width:1px; height:40px; background:rgba(255,255,255,.07); }

//         /* CTA */
//         .tsl-cta { text-align:center; margin-top:60px; padding:52px 40px; background:linear-gradient(135deg,rgba(94,14,115,.15),rgba(26,0,48,.5)); border:1px solid rgba(201,168,76,.1); border-radius:28px; position:relative; overflow:hidden; }
//         .tsl-cta::before { content:''; position:absolute; top:0; left:50%; transform:translateX(-50%); width:120px; height:1px; background:linear-gradient(90deg,transparent,${C.gold},transparent); }
//         .tsl-cta-h   { font-family:'Playfair Display',serif; font-size:clamp(22px,3vw,32px); font-weight:700; color:#fff; margin:0 0 8px; }
//         .tsl-cta-h span { color:${C.gold}; }
//         .tsl-cta-sub { font-size:14px; color:rgba(255,255,255,.4); margin-bottom:28px; }
//         .tsl-cta-row { display:flex; gap:14px; justify-content:center; flex-wrap:wrap; }
//         .tsl-btn-book { background:linear-gradient(135deg,${C.primary},${C.primaryLight}); color:#fff; border:none; border-radius:50px; padding:14px 32px; font-weight:700; font-size:14px; cursor:pointer; text-decoration:none; display:inline-block; box-shadow:0 6px 22px rgba(94,14,115,.4); transition:all .25s; }
//         .tsl-btn-book:hover { transform:translateY(-2px); color:#fff; box-shadow:0 12px 32px rgba(94,14,115,.55); }
//         .tsl-btn-wa { background:#25D366; color:#fff; border:none; border-radius:50px; padding:14px 32px; font-weight:700; font-size:14px; cursor:pointer; text-decoration:none; display:inline-flex; align-items:center; gap:8px; box-shadow:0 6px 22px rgba(37,211,102,.3); transition:all .25s; }
//         .tsl-btn-wa:hover { transform:translateY(-2px); background:#1ebe5d; color:#fff; }

//         @media(max-width:991px) { .tsl-ssep{display:none;} .tsl-plat{gap:20px;padding:20px 24px;} .tsl-psep{display:none;} }
//         @media(max-width:576px) { .tsl-sec{padding:64px 0 56px;} .tsl-cta{padding:36px 20px;} }
//       `}</style>

//       <section className="tsl-sec cc-sec" id="testimonials">
//         <div className="container" style={{ position: "relative", zIndex: 1 }}>

//           {/* Header */}
//           <div className="text-center rv">
//             <span className="tsl-tag">✦ Guest Stories ✦</span>
//             <h2 className="tsl-h">Real Celebrations,<br /><span>Real Magic</span></h2>
//             <p className="tsl-sub">Hear from our guests — their joy, their stories, their unforgettable moments at CarnivalCastle.</p>
//           </div>

//           {/* Stats */}
//           <div className="tsl-stats rv">
//             <div className="tsl-stat">
//               <div className="tsl-sn">{avgRating}</div>
//               <div style={{ display: "flex", justifyContent: "center", gap: 2, margin: "5px 0 4px" }}>
//                 {[1, 2, 3, 4, 5].map(n => <span key={n} style={{ fontSize: 11, color: C.gold }}>★</span>)}
//               </div>
//               <div className="tsl-sl">Average Rating</div>
//             </div>
//             <div className="tsl-ssep" />
//             <div className="tsl-stat"><div className="tsl-sn">500+</div><div className="tsl-sl">Happy Guests</div></div>
//             <div className="tsl-ssep" />
//             <div className="tsl-stat"><div className="tsl-sn">98%</div><div className="tsl-sl">Would Return</div></div>
//             <div className="tsl-ssep" />
//             <div className="tsl-stat"><div className="tsl-sn">4.9</div><div className="tsl-sl">Google Rating</div></div>
//           </div>

//           {/* Reviews */}
//           <div style={{ marginTop: 56 }}>
//             <div className="row g-4 align-items-stretch">

//               {/* Featured card */}
//               <div className="col-lg-7 rv" style={{ display: "flex" }}>
//                 <div className="tsl-feat">
//                   <div className="tsl-big-q">"</div>
//                   <div className="tsl-feat-in">
//                     <div className="tsl-fi-wrap">
//                       <img key={activeIdx} src={cur.image} alt={cur.name} className="tsl-fi" loading="lazy" />
//                       <div className="tsl-fi-ovl" />
//                       {cur.occasion && <div className="tsl-fi-badge">🎉 {cur.occasion}</div>}
//                     </div>
//                     <div style={{ marginBottom: 14 }}><Stars rating={cur.rating} size={15} /></div>
//                     <p className="tsl-review">"{cur.text}"</p>
//                     <div className="tsl-div" />
//                     <div className="tsl-author">
//                       <img src={cur.avatar} alt={cur.name} className="tsl-avatar" loading="lazy" />
//                       <div>
//                         <div className="tsl-aname">{cur.name}</div>
//                         <div className="tsl-aloc">{cur.location}</div>
//                       </div>
//                       <div className="tsl-v" title="Verified">✓</div>
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               {/* Preview cards */}
//               <div className="col-lg-5 rv" style={{ display: "flex", flexDirection: "column", gap: 16 }}>
//                 {[prev, next].map((rv, i) => (
//                   <div
//                     key={i}
//                     className="tsl-prev"
//                     onClick={() => goTo(i === 0
//                       ? (activeIdx - 1 + REVIEWS.length) % REVIEWS.length
//                       : (activeIdx + 1) % REVIEWS.length
//                     )}
//                   >
//                     <img src={rv.image} alt={rv.name} className="tsl-pi" loading="lazy" />
//                     <div className="tsl-pb">
//                       <Stars rating={rv.rating} size={11} />
//                       <p className="tsl-pt">"{rv.text}"</p>
//                       <div className="tsl-pn">{rv.name}</div>
//                       <div className="tsl-pl">{rv.location}</div>
//                       <span className="tsl-pr">Read Full →</span>
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             </div>

//             {/* Dot nav */}
//             <div className="tsl-nav">
//               <button className="tsl-arr" onClick={() => goTo(activeIdx - 1)}>‹</button>
//               {REVIEWS.map((_, i) => (
//                 <button key={i} className={`tsl-dot${i === activeIdx ? " on" : ""}`} onClick={() => goTo(i)} />
//               ))}
//               <button className="tsl-arr" onClick={() => goTo(activeIdx + 1)}>›</button>
//             </div>
//           </div>

//           {/* Platform ratings strip */}
//           <div className="tsl-plat rv">
//             {[
//               { name: "Google",    score: "4.9", count: "200+ reviews"   },
//               { name: "Facebook",  score: "4.8", count: "150+ reviews"   },
//               { name: "JustDial",  score: "4.7", count: "80+ reviews"    },
//               { name: "Instagram", score: "5.0", count: "50k+ followers" },
//             ].map((p, i) => (
//               <React.Fragment key={i}>
//                 {i > 0 && <div className="tsl-psep" />}
//                 <div className="tsl-plat-item">
//                   <div className="tsl-plat-name">{p.name}</div>
//                   <div className="tsl-plat-row">
//                     <span className="tsl-plat-sc">{p.score}</span>
//                     <div style={{ display: "flex", gap: 2 }}>
//                       {[1, 2, 3, 4, 5].map(n => <span key={n} style={{ fontSize: 11, color: C.gold }}>★</span>)}
//                     </div>
//                   </div>
//                   <div className="tsl-plat-cnt">{p.count}</div>
//                 </div>
//               </React.Fragment>
//             ))}
//           </div>

//           {/* CTA */}
//           <div className="tsl-cta rv">
//             <h3 className="tsl-cta-h">Ready to Create Your <span>Own Story?</span></h3>
//             <p className="tsl-cta-sub">Join thousands of guests who celebrated their most special moments with us.</p>
//             <div className="tsl-cta-row">
//               <a href="/locations" className="tsl-btn-book">🎉 Book My Celebration</a>
//               <a href="https://wa.me/918374777834" target="_blank" rel="noopener noreferrer" className="tsl-btn-wa">
//                 <i className="bi bi-whatsapp" /> Chat With Us
//               </a>
//             </div>
//           </div>

//         </div>
//       </section>
//     </>
//   );
// }
import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { URLS } from "../Url"; // Make sure this path is correct for your project

// ─── paste your existing C object or import it ───
const C = {
  primary:      "#5E0E73",
  primaryLight: "#6E1A85",
  gold:         "#C9A84C",
  goldLight:    "#E8D5A0",
  dark:         "#1A0030",
};

function Stars({ rating = 5, size = 13 }) {
  return (
    <div style={{ display: "flex", gap: 2 }}>
      {[1, 2, 3, 4, 5].map(n => (
        <span key={n} style={{ fontSize: size, color: n <= rating ? C.gold : "rgba(201,168,76,.2)" }}>★</span>
      ))}
    </div>
  );
}

/**
 * Self-contained Testimonials Component
 * Fetches its own data from the backend - no props needed!
 * Just drop <TestimonialsSection /> anywhere in your JSX
 */
export default function TestimonialsSection() {
  const [slides, setSlides] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeIdx, setActiveIdx] = useState(0);
  const autoRef = useRef(null);

  // Fetch testimonials data from backend
  useEffect(() => {
    const fetchTestimonials = async () => {
      try {
        const response = await axios.post(`https://api.carnivalcastle.com/v1/carnivalApi/admin/testimonial/getalltestimoni?websiteFor=carnivalcastle`);
        if (response.data?.success && Array.isArray(response.data.testimoni)) {
          const formattedReviews = response.data.testimoni
            .filter(t => t.status === "active")
            .map(t => ({
              name: t.name,
              location: t.role || "Customer",
              rating: Number(t.rating) || 5,
              description: t.description || "",
              image: `https://api.carnivalcastle.com/${t.image}`,
              avatar: `https://api.carnivalcastle.com/${t.profileImage}`,
              occasion: t.type === "Yes" ? "Special Celebration" : "",
            }));
          
          // Group into slides (3 reviews per slide - adjust as needed)
          const grouped = [];
          for (let i = 0; i < formattedReviews.length; i += 3) {
            grouped.push(formattedReviews.slice(i, i + 3));
          }
          setSlides(grouped);
        }
      } catch (error) {
        console.error("Error fetching testimonials:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchTestimonials();
  }, []);

  // Flatten slides for carousel
  const REVIEWS = slides.flat().map(rv => ({
    name:     rv.name,
    location: rv.location,
    rating:   rv.rating,
    occasion: rv.occasion,
    text:     rv.description ?? rv.text ?? "",
    image:    rv.image,
    avatar:   rv.avatar,
  }));

  const startAuto = () => {
    clearInterval(autoRef.current);
    if (REVIEWS.length === 0) return;
    autoRef.current = setInterval(
      () => setActiveIdx(i => (i + 1) % REVIEWS.length),
      4800
    );
  };

  useEffect(() => {
    if (REVIEWS.length === 0) return;
    startAuto();
    return () => clearInterval(autoRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [REVIEWS.length]);

  if (loading) {
    return (
      <section className="tsl-sec cc-sec" style={{ background: C.dark, minHeight: 400, display: "flex", alignItems: "center", justifyContent: "center" }}>
        <div className="container text-center">
          <div style={{ width: 48, height: 48, border: `3px solid ${C.gold}`, borderTopColor: "transparent", borderRadius: "50%", margin: "0 auto 16px", animation: "spin 1s linear infinite" }} />
          <p style={{ color: C.gold }}>Loading stories...</p>
          <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
        </div>
      </section>
    );
  }

  if (REVIEWS.length === 0) return null;

  const goTo = i => {
    setActiveIdx((i + REVIEWS.length) % REVIEWS.length);
    clearInterval(autoRef.current);
    startAuto();
  };

  const avgRating = (REVIEWS.reduce((s, r) => s + r.rating, 0) / REVIEWS.length).toFixed(1);
  const cur  = REVIEWS[activeIdx];
  const prev = REVIEWS[(activeIdx - 1 + REVIEWS.length) % REVIEWS.length];
  const next = REVIEWS[(activeIdx + 1) % REVIEWS.length];

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@600;700;900&family=DM+Sans:wght@300;400;500;600&display=swap');
        @keyframes spin { to { transform: rotate(360deg); } }

        .tsl-sec {
          padding: 100px 0 88px;
          background: ${C.dark};
          position: relative; overflow: hidden;
        }
        .tsl-sec::before {
          content: ''; position: absolute; inset: 0;
          background:
            radial-gradient(ellipse 70% 55% at 15% 5%,  rgba(94,14,115,.32) 0%, transparent 65%),
            radial-gradient(ellipse 55% 45% at 85% 95%, rgba(201,168,76,.09) 0%, transparent 65%),
            url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23fff' fill-opacity='0.018'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4z'/%3E%3C/g%3E%3C/svg%3E");
          pointer-events: none;
        }
        .tsl-sec::after {
          content: ''; position: absolute; top: 0; left: 50%; transform: translateX(-50%);
          width: 200px; height: 2px;
          background: linear-gradient(90deg, transparent, ${C.gold}, transparent);
        }

        .tsl-tag { display:inline-block; font-size:11px; font-weight:700; letter-spacing:3px; text-transform:uppercase; color:${C.gold}; margin-bottom:10px; }
        .tsl-h   { font-family:'Playfair Display',serif; font-size:clamp(30px,4.5vw,52px); font-weight:700; line-height:1.15; color:#fff; margin:0; }
        .tsl-h span { color:${C.gold}; }
        .tsl-sub { color:rgba(255,255,255,.5); font-size:14px; line-height:1.75; margin:12px auto 0; max-width:500px; }

        .tsl-stats { display:flex; align-items:center; justify-content:center; gap:40px; margin-top:40px; flex-wrap:wrap; }
        .tsl-stat  { text-align:center; }
        .tsl-sn    { font-family:'Playfair Display',serif; font-size:34px; font-weight:700; color:${C.gold}; line-height:1; }
        .tsl-sl    { font-size:10px; color:rgba(255,255,255,.4); letter-spacing:1.5px; text-transform:uppercase; margin-top:5px; }
        .tsl-ssep  { width:1px; height:44px; background:rgba(255,255,255,.08); }

        /* featured card */
        .tsl-feat {
          border-radius:28px; overflow:hidden; width:100%; height:100%;
          background:rgba(255,255,255,.04); border:1px solid rgba(201,168,76,.22);
          box-shadow:0 40px 90px rgba(0,0,0,.5),inset 0 1px 0 rgba(255,255,255,.06);
          position:relative; transition:all .5s cubic-bezier(.25,1,.5,1);
        }
        .tsl-feat::before { content:''; display:block; width:100%; height:2px; background:linear-gradient(90deg,transparent,${C.gold},transparent); }
        .tsl-feat-in { padding:30px 28px 26px; }
        .tsl-big-q { font-family:'Playfair Display',serif; font-size:130px; font-weight:900; line-height:.8; color:rgba(201,168,76,.055); position:absolute; top:20px; right:16px; user-select:none; pointer-events:none; }

        .tsl-fi-wrap { position:relative; width:100%; height:240px; overflow:hidden; border-radius:18px; margin-bottom:22px; box-shadow:0 14px 44px rgba(0,0,0,.45); }
        .tsl-fi { width:100%; height:100%; object-fit:cover; display:block; transition:transform .7s cubic-bezier(.25,1,.5,1); }
        .tsl-feat:hover .tsl-fi { transform:scale(1.04); }
        .tsl-fi-ovl { position:absolute; inset:0; background:linear-gradient(to top,rgba(26,0,48,.75) 0%,transparent 55%); }
        .tsl-fi-badge { position:absolute; bottom:14px; left:14px; background:rgba(201,168,76,.18); border:1px solid rgba(201,168,76,.4); color:${C.goldLight}; font-size:9px; font-weight:700; letter-spacing:1.5px; text-transform:uppercase; padding:4px 12px; border-radius:50px; backdrop-filter:blur(8px); }

        .tsl-review { font-size:15px; color:rgba(255,255,255,.82); line-height:1.8; font-style:italic; margin:0 0 22px; }
        .tsl-div    { height:1px; margin-bottom:18px; background:linear-gradient(90deg,transparent,rgba(201,168,76,.28),transparent); }
        .tsl-author { display:flex; align-items:center; gap:14px; }
        .tsl-avatar { width:52px; height:52px; border-radius:50%; object-fit:cover; flex-shrink:0; border:2.5px solid rgba(201,168,76,.45); box-shadow:0 0 0 4px rgba(201,168,76,.1); }
        .tsl-aname  { font-family:'Playfair Display',serif; font-size:16px; font-weight:700; color:#fff; }
        .tsl-aloc   { font-size:11px; color:rgba(255,255,255,.4); text-transform:uppercase; letter-spacing:.5px; margin-top:2px; }
        .tsl-v      { margin-left:auto; flex-shrink:0; width:30px; height:30px; border-radius:50%; background:linear-gradient(135deg,${C.primary},${C.gold}); display:flex; align-items:center; justify-content:center; font-size:12px; color:#fff; font-weight:700; box-shadow:0 3px 12px rgba(201,168,76,.35); }

        /* preview cards */
        .tsl-prev { background:rgba(255,255,255,.03); border:1px solid rgba(201,168,76,.08); border-radius:20px; overflow:hidden; cursor:pointer; transition:all .3s; display:flex; flex-direction:column; flex:1; }
        .tsl-prev:hover { background:rgba(255,255,255,.06); border-color:rgba(201,168,76,.28); transform:translateY(-5px); box-shadow:0 18px 52px rgba(0,0,0,.45); }
        .tsl-pi  { width:100%; height:155px; object-fit:cover; display:block; transition:transform .45s,filter .3s; filter:brightness(.8); }
        .tsl-prev:hover .tsl-pi { transform:scale(1.05); filter:brightness(1); }
        .tsl-pb  { padding:15px 17px; flex:1; display:flex; flex-direction:column; }
        .tsl-pt  { font-size:12px; color:rgba(255,255,255,.55); line-height:1.65; font-style:italic; margin:8px 0 10px; flex:1; display:-webkit-box; -webkit-line-clamp:3; -webkit-box-orient:vertical; overflow:hidden; }
        .tsl-pn  { font-size:13px; font-weight:700; color:rgba(255,255,255,.85); font-family:'Playfair Display',serif; }
        .tsl-pl  { font-size:10px; color:rgba(255,255,255,.3); margin-top:2px; }
        .tsl-pr  { display:inline-block; margin-top:10px; font-size:10px; font-weight:700; color:${C.gold}; letter-spacing:1px; text-transform:uppercase; padding:4px 12px; border:1px solid rgba(201,168,76,.25); border-radius:50px; transition:all .2s; background:transparent; width:fit-content; }
        .tsl-prev:hover .tsl-pr { background:rgba(201,168,76,.12); border-color:rgba(201,168,76,.5); }

        /* nav */
        .tsl-nav  { display:flex; justify-content:center; align-items:center; gap:8px; margin-top:36px; }
        .tsl-dot  { width:8px; height:8px; border-radius:50%; background:rgba(255,255,255,.15); border:none; cursor:pointer; transition:all .35s cubic-bezier(.25,1,.5,1); padding:0; }
        .tsl-dot.on { width:34px; border-radius:4px; background:linear-gradient(90deg,${C.primary},${C.gold}); box-shadow:0 0 14px rgba(201,168,76,.4); }
        .tsl-arr  { width:46px; height:46px; border-radius:50%; background:rgba(255,255,255,.06); border:1px solid rgba(255,255,255,.12); color:rgba(255,255,255,.6); font-size:20px; cursor:pointer; transition:all .25s; display:flex; align-items:center; justify-content:center; backdrop-filter:blur(8px); }
        .tsl-arr:hover { background:${C.gold}; color:${C.dark}; border-color:${C.gold}; box-shadow:0 6px 20px rgba(201,168,76,.4); }

        /* platform strip */
        .tsl-plat { display:flex; justify-content:center; align-items:center; gap:32px; flex-wrap:wrap; margin-top:60px; padding:26px 44px; background:rgba(255,255,255,.025); border:1px solid rgba(255,255,255,.055); border-radius:22px; }
        .tsl-plat-item { text-align:center; }
        .tsl-plat-name { font-size:10px; color:rgba(255,255,255,.3); letter-spacing:2px; text-transform:uppercase; margin-bottom:6px; }
        .tsl-plat-row  { display:flex; align-items:center; gap:7px; }
        .tsl-plat-sc   { font-family:'Playfair Display',serif; font-size:22px; font-weight:700; color:#fff; }
        .tsl-plat-cnt  { font-size:10px; color:rgba(255,255,255,.25); margin-top:3px; }
        .tsl-psep      { width:1px; height:40px; background:rgba(255,255,255,.07); }

        /* CTA */
        .tsl-cta { text-align:center; margin-top:60px; padding:52px 40px; background:linear-gradient(135deg,rgba(94,14,115,.15),rgba(26,0,48,.5)); border:1px solid rgba(201,168,76,.1); border-radius:28px; position:relative; overflow:hidden; }
        .tsl-cta::before { content:''; position:absolute; top:0; left:50%; transform:translateX(-50%); width:120px; height:1px; background:linear-gradient(90deg,transparent,${C.gold},transparent); }
        .tsl-cta-h   { font-family:'Playfair Display',serif; font-size:clamp(22px,3vw,32px); font-weight:700; color:#fff; margin:0 0 8px; }
        .tsl-cta-h span { color:${C.gold}; }
        .tsl-cta-sub { font-size:14px; color:rgba(255,255,255,.4); margin-bottom:28px; }
        .tsl-cta-row { display:flex; gap:14px; justify-content:center; flex-wrap:wrap; }
        .tsl-btn-book { background:linear-gradient(135deg,${C.primary},${C.primaryLight}); color:#fff; border:none; border-radius:50px; padding:14px 32px; font-weight:700; font-size:14px; cursor:pointer; text-decoration:none; display:inline-block; box-shadow:0 6px 22px rgba(94,14,115,.4); transition:all .25s; }
        .tsl-btn-book:hover { transform:translateY(-2px); color:#fff; box-shadow:0 12px 32px rgba(94,14,115,.55); }
        .tsl-btn-wa { background:#25D366; color:#fff; border:none; border-radius:50px; padding:14px 32px; font-weight:700; font-size:14px; cursor:pointer; text-decoration:none; display:inline-flex; align-items:center; gap:8px; box-shadow:0 6px 22px rgba(37,211,102,.3); transition:all .25s; }
        .tsl-btn-wa:hover { transform:translateY(-2px); background:#1ebe5d; color:#fff; }

        @media(max-width:991px) { .tsl-ssep{display:none;} .tsl-plat{gap:20px;padding:20px 24px;} .tsl-psep{display:none;} }
        @media(max-width:576px) { .tsl-sec{padding:64px 0 56px;} .tsl-cta{padding:36px 20px;} }
      `}</style>

      <section className="tsl-sec cc-sec" id="testimonials">
        <div className="container" style={{ position: "relative", zIndex: 1 }}>

          {/* Header */}
          <div className="text-center rv">
            <span className="tsl-tag">✦ Guest Stories ✦</span>
            <h2 className="tsl-h">Real Celebrations,<br /><span>Real Magic</span></h2>
            <p className="tsl-sub">Hear from our guests — their joy, their stories, their unforgettable moments at CarnivalCastle.</p>
          </div>

          {/* Stats */}
          <div className="tsl-stats rv">
            <div className="tsl-stat">
              <div className="tsl-sn">{avgRating}</div>
              <div style={{ display: "flex", justifyContent: "center", gap: 2, margin: "5px 0 4px" }}>
                {[1, 2, 3, 4, 5].map(n => <span key={n} style={{ fontSize: 11, color: C.gold }}>★</span>)}
              </div>
              <div className="tsl-sl">By Families</div>
            </div>
            <div className="tsl-ssep" />
            <div className="tsl-stat"><div className="tsl-sn">50k+</div><div className="tsl-sl">Happy Guests</div></div>
            <div className="tsl-ssep" />
            <div className="tsl-stat"><div className="tsl-sn">5★</div><div className="tsl-sl">Rated By Couples</div></div>
            <div className="tsl-ssep" />
            <div className="tsl-stat"><div className="tsl-sn">4.9★</div><div className="tsl-sl">Google Rating</div></div>
          </div>

       

          {/* Reviews */}
          <div style={{ marginTop: 56 }}>
            <div className="row g-4 align-items-stretch">

              {/* Featured card */}
              <div className="col-lg-7 rv" style={{ display: "flex" }}>
                <div className="tsl-feat">
                  <div className="tsl-big-q">"</div>
                  <div className="tsl-feat-in">
                    <div className="tsl-fi-wrap">
                      <img key={activeIdx} src={cur.image} alt={cur.name} className="tsl-fi" loading="lazy" />
                      <div className="tsl-fi-ovl" />
                      {cur.occasion && <div className="tsl-fi-badge">🎉 {cur.occasion}</div>}
                    </div>
                    <div style={{ marginBottom: 14 }}><Stars rating={cur.rating} size={15} /></div>
                    <p className="tsl-review">"{cur.text}"</p>
                    <div className="tsl-div" />
                    <div className="tsl-author">
                      <img src={cur.avatar} alt={cur.name} className="tsl-avatar" loading="lazy" />
                      <div>
                        <div className="tsl-aname">{cur.name}</div>
                        <div className="tsl-aloc">{cur.location}</div>
                      </div>
                      <div className="tsl-v" title="Verified">✓</div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Preview cards */}
              <div className="col-lg-5 rv" style={{ display: "flex", flexDirection: "column", gap: 16 }}>
                {[prev, next].map((rv, i) => (
                  <div
                    key={i}
                    className="tsl-prev"
                    onClick={() => goTo(i === 0
                      ? (activeIdx - 1 + REVIEWS.length) % REVIEWS.length
                      : (activeIdx + 1) % REVIEWS.length
                    )}
                  >
                    <img src={rv.image} alt={rv.name} className="tsl-pi" loading="lazy" />
                    <div className="tsl-pb">
                      <Stars rating={rv.rating} size={11} />
                      <p className="tsl-pt">"{rv.text}"</p>
                      <div className="tsl-pn">{rv.name}</div>
                      <div className="tsl-pl">{rv.location}</div>
                      <span className="tsl-pr">Read Full →</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Dot nav */}
            <div className="tsl-nav">
              <button className="tsl-arr" onClick={() => goTo(activeIdx - 1)}>‹</button>
              {REVIEWS.map((_, i) => (
                <button key={i} className={`tsl-dot${i === activeIdx ? " on" : ""}`} onClick={() => goTo(i)} />
              ))}
              <button className="tsl-arr" onClick={() => goTo(activeIdx + 1)}>›</button>
            </div>
          </div>

          {/* Platform ratings strip */}
          <div className="tsl-plat rv">
            {[
              { name: "Google",    score: "4.9", count: "200+ reviews"   },
              { name: "Facebook",  score: "4.8", count: "150+ reviews"   },
              { name: "JustDial",  score: "4.7", count: "80+ reviews"    },
              // { name: "Instagram", score: "5.0", count: "10k+ followers" },
            ].map((p, i) => (
              <React.Fragment key={i}>
                {i > 0 && <div className="tsl-psep" />}
                <div className="tsl-plat-item">
                  <div className="tsl-plat-name">{p.name}</div>
                  <div className="tsl-plat-row">
                    <span className="tsl-plat-sc">{p.score}</span>
                    <div style={{ display: "flex", gap: 2 }}>
                      {[1, 2, 3, 4, 5].map(n => <span key={n} style={{ fontSize: 11, color: C.gold }}>★</span>)}
                    </div>
                  </div>
                  <div className="tsl-plat-cnt">{p.count}</div>
                </div>
              </React.Fragment>
            ))}
          </div>

          {/* CTA */}
          <div className="tsl-cta rv">
            <h3 className="tsl-cta-h">Ready to Create Your <span>Own Story?</span></h3>
            <p className="tsl-cta-sub">Join thousands of guests who celebrated their most special moments with us.</p>
            <div className="tsl-cta-row">
              <a href="/locations" className="tsl-btn-book">🎉 Book My Celebration</a>
              <a href="https://wa.me/918374777834" target="_blank" rel="noopener noreferrer" className="tsl-btn-wa">
                <i className="bi bi-whatsapp" /> Chat With Us
              </a>
            </div>
          </div>

        </div>
      </section>
    </>
  );
}